const ROUTE_CONSTANTS = {
  PROTECTED_ROUTE: '/protected_route',
  PUBLIC_ROUTE: '/public_route',
  LOGIN_VIEW: '/propertyOnboard/login',
  OTPSIGNUP_VIEW: '/propertyOnboard/sign_up',
  OTPSIGNUP_VIEW_V2: '/propertyOnboard/:country_iso_code/sign_up',
  SOCIAL_LOGIN: '/propertyOnboard/social_login/:oauth_mode',
  PROPERTY_MIDDLEWARE: '/propertyOnboard',
  PROPERTY_MIDDLEWARE_V2: '/propertyOnboard/:country_iso_code',
  PROPERTY_INFO: '/propertyOnboard/add',
  PROPERTY_INFO_V2: '/propertyOnboard/:country_iso_code/add',
  PROPERTY_KYC: '/propertyOnboard/kyc',
  PROPERTY_IMAGES: '/propertyOnboard/images',
  PROPERTY_ONBOARD_TASK: '/propertyOnboard/task',
  PROPERTY_ONBOARD_TASK_V2: '/propertyOnboard/:country_iso_code/task',
  PROPERTY_ONBOARD_TASk_DETAILS: '/propertyOnboard/task/details',
  PROPERTY_ONBOARD_TASk_DETAILS_V2: '/propertyOnboard/:country_iso_code/task/details',
  PROPERTY_DETAILS_REVIEWS: '/propertyOnboard/review',
  PROPERTY_DETAILS_REVIEWS_V2: '/propertyOnboard/:country_iso_code/review',
  PROPERTY_ONBOARD_ACCOUNT: '/propertyOnboard/account',
  PROPERTY_ONBOARD_ACCOUNT_V2: '/propertyOnboard/:country_iso_code/account',
  PROPERTY_ONBOARD_DASHBOARD: '/propertyOnboard/dashboard',
  PROPERTY_ONBOARD_DASHBOARD_V2: '/propertyOnboard/:country_iso_code/dashboard',
  OYO360_PROPERTY_ONBOARD: '/route/redirect/propertyOnboard',
  OYO360_PROPERTY_ONBOARD_V2: '/route/redirect/propertyOnboard/:country_iso_code'
};

export const FULL_SCREEN_ROUTES = {}

export default ROUTE_CONSTANTS;
